// extracted by mini-css-extract-plugin
export default {"message":"classes@mobile_message__njQmM"};